import React from 'react';

import { suspenseWrapper } from 'utils/suspenseWrapper';


export const agentsRoute = [
  {
    path: '',
    async lazy() {
      const  { Agents } = await import("../pages/agents/All/Agents");
      return { Component: () => suspenseWrapper(<Agents />) };
    }
  }
];
